import { MasterGroupGetCollectionByTrialCode, MasterGroupCollectionResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<MasterGroupCollectionResponse, MasterGroupCollectionResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<MasterGroupCollectionResponse, MasterGroupCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useMasterGroups = (trialCode: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new MasterGroupGetCollectionByTrialCode({ trialCode }) : 
            undefined;
    }, [trialCode]);

    return useGet(request, { getData, getError}, configuration);
};

export default useMasterGroups;